import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit} from '@angular/core';
import {OrganizationService} from '@services/organization/organization.service';
import {Organization} from '@interfaces/organization';
import {NzListComponent, NzListEmptyComponent, NzListHeaderComponent, NzListItemComponent} from 'ng-zorro-antd/list';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzCardComponent} from 'ng-zorro-antd/card';
import {NzColDirective, NzRowDirective} from 'ng-zorro-antd/grid';
import {NzDescriptionsComponent, NzDescriptionsItemComponent} from 'ng-zorro-antd/descriptions';
import {NzDividerComponent} from 'ng-zorro-antd/divider';
import {NzButtonComponent} from 'ng-zorro-antd/button';
import {Router} from '@angular/router';
import {NzInputDirective, NzInputGroupComponent} from 'ng-zorro-antd/input';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-organization-table',
  imports: [
    NzListComponent,
    NzListItemComponent,
    NzListEmptyComponent,
    NzIconModule,
    NzCardComponent,
    NzColDirective,
    NzRowDirective,
    NzDescriptionsComponent,
    NzDescriptionsItemComponent,
    NzDividerComponent,
    NzButtonComponent,
    NzInputGroupComponent,
    NzListHeaderComponent,
    NzInputDirective,
    FormsModule
  ],
  templateUrl: './organization-table.component.html',
  styleUrl: './organization-table.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OrganizationTableComponent implements OnInit {

  organizations: Organization[] = [];
  loading = false;
  searchTest: string = '';

  private organizationService = inject(OrganizationService);
  private router = inject(Router);


  ngOnInit() {
    this.loading = true;
    this.organizationService.fetchOrganizations()
      .subscribe({
        next: (data: any) => {
          this.loading = false;
          this.organizations = data;
        },
        error: (error: any) => {
          this.loading = false;
          console.error('Error fetching organizations:', error);
        },
      });
  }

  openAddNew() {
    this.router.navigate(['/organization/new']);
  }

  openOrganization(item: Organization) {
    this.router.navigate(['/organization', item.id]);
  }

  filterResults() {
    if (this.searchTest && this.searchTest.length > 0) {
      this.organizations = this.organizations.filter((item: Organization) => {
        return item.name.toLowerCase().includes(this.searchTest.toLowerCase());
      });
    } else {
      this.organizationService.fetchOrganizations()
        .subscribe((data: any) => {
          this.organizations = data;
        });
    }
  }
}
